import { Bid, BridgePosition, ForeignBoardReviewData, ForeignBoardReviewPlayerData } from '../../app/types';
import { SharkBidComponent } from '../shark-bid-component/shark-bid-component';
import { classNames, getMySeatData, isVulnerable } from '../../utils/mixed';
import { outputActions } from '../../slices/outputSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useRef, useState } from 'react';

import './auction-box-component.scss';
import { convertStringToBid } from '../../app-interfaces/shark-game-engine-helper';
import { isMobile } from 'react-device-detect';
import { useGesture } from '@use-gesture/react';

const rotationHelper = [
    BridgePosition.north,
    BridgePosition.east,
    BridgePosition.south,
    BridgePosition.west,
    BridgePosition.north,
    BridgePosition.east,
    BridgePosition.south,
    BridgePosition.west,
];

export type AuctionBoxProps = {
    foreignBoardData?: Pick<ForeignBoardReviewData, 'seatData' | 'vulnerable' | 'showAuctionBox'> & {
        auction: ForeignBoardReviewPlayerData['auction'];
    };
};

const AuctionBoxComponent: FunctionComponent<AuctionBoxProps> = ({ foreignBoardData }) => {
    const { t } = useTranslation();

    const [lastAuctionLength, setLastAuctionLength] = useState<number>(0);
    const currentBidder = useRef(null);
    const {
        seatData: reduxSeatData,
        vulnerable: reduxVulnerable,
        showAuctionBox: reduxShowAuctionBox,
        auction: reduxAuction,
        dealer,
    } = useAppSelector((state) => state.table);
    const { sharkLayout } = useAppSelector((state) => state.app);

    let seatData = reduxSeatData;
    let vulnerable = reduxVulnerable;
    let showAuctionBox = reduxShowAuctionBox;
    let auction = reduxAuction;

   // console.log('AuctionBoxComponent render', { foreignBoardData, auction });

    if (foreignBoardData) {
        seatData = foreignBoardData.seatData;
        vulnerable = foreignBoardData.vulnerable;
        showAuctionBox = foreignBoardData.showAuctionBox;
        auction = foreignBoardData.auction;
    }

    const { selectedCardSet } = sharkLayout;

    const mySeatData = getMySeatData(seatData);

    if (lastAuctionLength !== auction.length) {
        setLastAuctionLength(auction.length);
        setTimeout(() => {
            if (currentBidder?.current) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // currentBidder.current.scrollIntoView({
                //     behavior: 'smooth'
                // });
            }
        }, 100);
    }

    if (!mySeatData?.bridgePosition) {
        return null;
    }

    const index = rotationHelper.indexOf(mySeatData.bridgePosition);
    const auctionRotation = rotationHelper.slice(index + 1, index + 5);
    let dealerIndex = 0;

    const renderBiddingHistory = () => {
        const shiftedBiddingHistory: (Bid | undefined)[] = [undefined, undefined, undefined, undefined];
        const biddingHistory = shiftedBiddingHistory.slice(0, dealerIndex).concat(auction);

        return biddingHistory
            .map((call, index) => {
                if (call?.call) {
                     return (
                        <td
                            key={`call-${index}`}
                        >
                            <SharkBidComponent
                                key = {`${call.level}-${call.strain}-${index}`}
                                bid = {call}
                                selectedCardSet = {selectedCardSet}
                                indexDealerIndex = {index - dealerIndex}
                                activeHover = {true}
                            />
                        </td>
                    );
                } else {
                    const props = {
                        className: 'empty',
                        ...(index === biddingHistory.length - 1 ? { id: 'currentBidder' } : {}),
                        ...(index === biddingHistory.length - 1 ? { ref: currentBidder } : {}),
                    };
                    return <td key={`empty-${index}`} {...props} />;
                }
            })
            .reduce((prev: JSX.Element[][], curr: JSX.Element, index) => {
                const _prev = [...prev];
                if (index % 4 === 0) {
                    _prev.push([]);
                }
                _prev[_prev.length - 1].push(curr);
                return _prev;
            }, [])
            .map((tr, index) => <tr key={`tr-${index}`}>{tr}</tr>);
    };

    return (
        <section
            className={classNames(
                'AuctionBoxComponent',
                `vulnerable-${vulnerable}`,
                showAuctionBox ? 'showAuctionBox' : 'hideAuctionBox',
            )}
        >
            <div className="thead">
                <table className="auction">
                    <thead className="bridgePositions">
                        <tr>
                            {auctionRotation.map((bridgePosition, index) => {
                                if (dealer === bridgePosition) {
                                    dealerIndex = index;
                                }
                                return (
                                    <th
                                        key={`bridgePosition-${index}`}
                                        className={`bridgePosition ${
                                            isVulnerable(bridgePosition, vulnerable) ? 'vulnerable' : ''
                                        }`}
                                    >
                                        {t(`bridgePosition.${bridgePosition}`)}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                </table>
            </div>
            <div className="tbody">
                <table className="auction">
                    <tbody className="setWidths">
                        <tr>
                            <td />
                            <td />
                            <td />
                            <td />
                        </tr>
                    </tbody>
                    <tbody className="calls">{renderBiddingHistory()}</tbody>
                </table>
            </div>
        </section>
    );
};

export default AuctionBoxComponent;
